<style lang="scss" scoped>
@include component(match) {
	@include part(header) {
		@include part(steps) {
			margin-top: 20px;
		}
	}
	@include part(description) {
		padding: 0;
		margin: 0;
	}
}
</style>
<template lang="pug">
.match
	app-header
		.match__header(slot="header")
			h1 Connect to {{ providerFullName }}
			.match__header__steps
				el-steps(:active="2", finish-status="success")
					el-step(title="Connect")
					el-step(title="Settings")
					el-step(title="Match")
	.container
		.main-panel.directory
			loading(v-if="$apollo.loading")
			template(v-else="")
				.main-panel__padding
					p.match__description 
						| Below are predicted matches for the data stored in Wonde compared to the users already in your {{ providerName }} account.
						| Please review these, and click <b>Save</b> once you are happy that you have ignored any incorrect matches.
						| You will be able to work with ignored matches once setup is complete.
				el-table.custom-table.border-top(:row-class-name="tableRowClassName", :data="predictions", style="width: 100%")
					el-table-column(prop="WondeUser.last_name", sortable="", label="Wonde user")
						template(slot-scope="scope")
							| {{ scope.row.WondeUser.first_name }} {{ scope.row.WondeUser.last_name }}
					el-table-column(prop="ThirdPartyUser.last_name", sortable="", :label="`${providerName} user`")
						template(slot-scope="scope")
							| {{ scope.row.ThirdPartyUser.first_name }} {{ scope.row.ThirdPartyUser.last_name }}
					el-table-column(prop="ThirdPartyUser.email", sortable="", :label="`${providerName} email`")
					el-table-column(width="120", prop="type", label="Type")
						template(slot-scope="scope")
							| {{ scope.row.WondeUser.base_type | capitalize }}
					el-table-column(prop="score", sortable="", label="Prediction strength")
						template(slot-scope="scope")
							template(v-if="scope.row.skip")
								el-progress(v-if="scope.row.rank === 'confident'", :percentage="100", status="exception")
								el-progress(v-if="scope.row.rank === 'likely'", :percentage="80", status="exception")
								el-progress(v-if="scope.row.rank === 'weak'", :percentage="40", status="exception")
							template(v-else="")
								el-progress(v-if="scope.row.rank === 'confident'", :percentage="100", status="success")
								el-progress(v-if="scope.row.rank === 'likely'", :percentage="80", status="success")
								el-progress(v-if="scope.row.rank === 'weak'", :percentage="40", status="exception")
					el-table-column(width="150", align="center", label="Action")
						template(slot-scope="scope")
							el-button(:type="scope.row.skip ? 'danger' : 'secondary'", @click="skip(scope.row)", size="small") {{ scope.row.skip ? 'Ignored' : 'Ignore' }}
				.main-panel__footer.d-flex.align-items-center
					el-button.ml-auto.mega-action(@click="skipAll") Ignore all
					el-button.mega-action(type="success", @click="save", :loading="loading") Match
</template>
<script>
import _ from "lodash";
import gql from "graphql-tag";
export default {
	data() {
		return {
			loading: false,
		};
	},
	apollo: {
		predictions: {
			query: gql`
				{
					Predictions {
						WondeUser {
							id
							first_name
							last_name
							email
							base_type
						}
						ThirdPartyUser {
							id
							first_name
							last_name
							email
						}
						rank
					}
				}
			`,
			update(r) {
				if (!r || !r.Predictions || !r.Predictions.length) {
					this.$apollo
						.mutate({
							mutation: gql`
								mutation {
									WizardStatus(complete: true) {
										id
										has_completed_wizard
									}
								}
							`,
						})
						.then((r) => {
							return this.$router.push({ name: "directory" });
						});
				} else {
					let data = _.cloneDeep(r.Predictions);
					data = _.map(data, (i) => {
						switch (i.rank) {
							case "confident":
								i.score = 1;
								i.skip = false;
								break;
							case "likely":
								i.score = 2;
								i.skip = false;
								break;
							case "weak":
								i.score = 3;
								i.skip = true;
								break;
							default:
								i.skip = true;
								i.score = 4;
								break;
						}
						return i;
					});
					return data;
				}
			},
		},
	},
	methods: {
		async save() {
			this.loading = true;
			try {
				await this.$apollo.mutate({
					mutation: gql`
						mutation SavePredictions($input: [PredictionsInput]!) {
							SavePredictions(input: $input) {
								id
								has_completed_wizard
							}
						}
					`,
					variables: {
						input: _.map(this.predictions, (r) => {
							return {
								idpId: r.WondeUser.id,
								spId: r.ThirdPartyUser.id,
								action: r.skip == true ? "unmatch" : "match",
							};
						}),
					},
				});
				this.$router.push({ name: "directory" });
			} catch (e) {
				this.$message.error("Failed to update, please contact support if issue continues");
			}
			this.loading = false;
		},
		skipWeak() {
			_.each(this.predictions, (r) => {
				if (r.rank === "weak") {
					this.$set(r, "skip", true);
				}
			});
		},
		skipAll() {
			_.each(this.predictions, (r) => {
				this.$set(r, "skip", true);
			});
		},
		tableRowClassName({ row }) {
			return row.skip ? "skipped" : "included";
		},
		skip(row) {
			this.$set(row, "skip", !row.skip);
		},
	},
};
</script>